import React from 'react';
import { Text } from '@myob/myob-widgets';
import { FEELIX_THEMES } from '../../../constants';

/**
 * Display this disclaimer text only for partner program.
 */
export const PaymentInfo: React.FC<{ theme: string }> = ({ theme }) => {
  if (theme !== FEELIX_THEMES.PARTNER) {
    return null;
  }

  return (
    <Text
      fontSize='sm'
      tone='neutral'
      marginTop='xs'
      // `normal` is not 400 in FEELIX, why?
      style={{ fontWeight: 400 }}
    >
      {
        "We'll use your payment details when you choose to purchase products for your business or your clients."
      }
    </Text>
  );
};
